<template>
	<div class="col-6">
		<new-yb-line-item
				:action="this.newLineItemAction.EDIT"
				v-if="createEditLineItemModal"
				v-model="showEditLineItemModal"
				:ndc-number="this.record.fieldData['NDC Number']"
				:initial-source="record.fieldData['Source']"
				:initial-source-number="record.fieldData['Source Number']"
				:initial-cause="record.fieldData['Cause']"
				:initial-lot-number="record.fieldData['Lot Number']"
				:initial-pack-quantity="record.fieldData['Pack Quantity']"
				:initial-pack-qty-uo-m="record.fieldData['Pack Quantity UoM']"
				:initial-pack-size="record.fieldData['Pack Size']"
				:initial-pack-size-uo-m="record.fieldData['Pack Size UoM']"
				:initial-percent-fill="record.fieldData['Percent Fill']"
				:initial-bulk-pack-size="record.fieldData['YI Package Size Bulk Blend']"
				:initial-bulk-pack-size-uo-m="record.fieldData['YI Package Size Bulk Blend UoM']"
				:container-id="record.fieldData['Container ID']"
				:id="record.fieldData['Container Line Item ID']"
        :initial-schedule="record.fieldData['NDC Schedule']"
				:is-new-line-item="false"
				@created="onLineItemEdited"
		></new-yb-line-item>
		<div class="card">
			<div class="card-header pt-2 pb-2">
				<div class="row">
					<div class="col-6">
						<span>Yellow Bucket Line Item Info</span>
					</div>
				</div>
			</div>
			<div v-show="accessPrivileges.includes('CREATE_LINE_ITEM') && !locked" class="list-group list-group-flush">
				<div class="list-group-item pt-1 pb-1">
					<a href="" @click.prevent="editLineItem">
						Edit
						<font-awesome-icon icon="edit"></font-awesome-icon>
					</a>
				</div>
			</div>
			<div class="card-body">
				<div class="row mb-1">
					<div class="col-4">
						<strong>Source Number</strong>
						<div class="job-field">{{ record.fieldData['Source Number'] }}</div>
					</div>
					<div class="col-8">
						<strong>Source</strong>
						<div class="job-field">{{ record.fieldData['Source'] }}</div>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col-4">
						<strong>Lot Number</strong>
						<div class="job-field">{{ record.fieldData['Lot Number'] }}</div>
					</div>
					<div class="col-8">
						<strong>Cause</strong>
						<div class="job-field">{{ record.fieldData['Cause'] }}</div>
					</div>
				</div>
				<hr/>
				<div class="row mb-1">
					<div class="col-3">
						<div><strong>Pack Qty</strong></div>
						<div class="job-field">{{ record.fieldData['Pack Quantity'] }}</div>
					</div>
					<div class="col-6">
						<strong>Type</strong>
						<div class="job-field ">{{ record.fieldData['Pack Quantity UoM'] }}</div>
					</div>
					<div class="col-3">
						<div v-if="isBulk"><strong>% Purity</strong></div>
						<div v-else><strong>% Fill</strong></div>
						<div class="job-field">{{ percentFill }}</div>
					</div>
				</div>
				<!--Pack_Size-->
				<!--Pack_Size_UoM-->
				<div class="row mb-1">
					<div class="col-3">
						<div><strong>Pack Size**</strong></div>
						<div v-if="isBulk" class="job-field">{{ record.fieldData['Pack Size'] }}</div>
						<div v-else class="job-field">
							{{ record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Package Size Converted LU'] }}
						</div>
					</div>
					<div class="col-3">
						<strong>UoM</strong>
						<div v-if="isBulk" class="job-field ">{{ record.fieldData['Pack Size UoM'] }}</div>
						<div v-else class="job-field ">
							{{ record.fieldData['hcn.holding_li_SHOWCN_danox_dic::Package Size UoM LU'] }}
						</div>
					</div>
					<div v-show="!isBulk && hasFactor" class="offset-3 col-3">
						<strong>Converted</strong>
						<div class="job-field ">{{ record.fieldData['converteToBase'] }}</div>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col-3">
						<div><strong>Ordered Qty</strong></div>
						<div class="job-field">{{ this.orderedQty }}</div>
					</div>
					<!--<div class="col-3">
						<strong>UoM</strong>
						<div class="job-field ">{{record.fieldData['Ordered Quantity UoM CALC']}}</div>
					</div>-->
				</div>
				<div v-show="record.fieldData['Reporting Qty'] > 0" class="row mb-1">
					<div class="col-3">
						<div><strong>Shipped Qty</strong></div>
						<div class="job-field">{{ record.fieldData['Reporting Qty'] }}</div>
					</div>
					<div class="col-3">
						<strong>UoM</strong>
						<div class="job-field ">{{ record.fieldData['Reporting UoM'] }}</div>
					</div>
				</div>
				<hr v-show="showStage || showUnit"/>
				<div class="row mb-1">
					<div class="col-6 card-title" v-show="showUnit">
						<h6 class="mb-2" style="text-decoration: underline;">Unit Converter</h6>
						<div class="row">
							<div class="col-6">
								<div><strong>Amt</strong></div>
								<div class="job-field">{{ record.fieldData['YI Package Size Bulk Blend'] }}</div>
							</div>
							<div class="col-6">
								<strong>UoM</strong>
								<div class="job-field ">{{ record.fieldData['YI Package Size Bulk Blend UoM'] }}</div>
							</div>
						</div>
					</div>
					<div class="col-6 card-title" :class="{'converter-divider': showUnit}"
						 v-show="showStage">
						<h6 class="mb-2" style="text-decoration: underline">Stage Converter</h6>
						<div class="row">
							<div class="col-12">
								<div><strong>Stage</strong></div>
								<div class="job-field">
									{{ record.fieldData['YI Package Size Bulk Blend Chosen Stage'] }}
								</div>
							</div>
						</div>
					</div>
					<!--<div class="col-6 card-title">
						<h6 class="mb-0" style="text-decoration: underline">Stage Converter</h6>
					</div>
					<div class="col-3">
						<div><strong>Amt</strong></div>
						<div class="job-field">{{record.fieldData['YI Package Size Bulk Blend']}}</div>
					</div>
					<div class="col-3">
						<strong>UoM</strong>
						<div class="job-field ">{{record.fieldData['YI Package Size Bulk Blend UoM']}}</div>
					</div>
					<div class="col-6">
						<div><strong>Stage</strong></div>
						<div class="job-field">{{record.fieldData['YI Package Size Bulk Blend Chosen Stage']}}</div>
					</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseView from '../BaseView'
import ybLineItemMixin from '../../mixins/yb-line-item'
import NewYbLineItem from "@/components/NewYBLineItem";
import newLineItemMixin from "@/mixins/new-line-item-action";
import NewLineItem from "@/components/NewLineItem.vue";

export default {
	name: "YBLineItemView",
	components: {NewLineItem, NewYbLineItem},
	extends: BaseView,
	mixins: [ybLineItemMixin, newLineItemMixin],
	data() {
		return {
			createEditLineItemModal: false,
			showEditLineItemModal: false,
		}
	},
	methods: {
		onLineItemEdited(event) {
			this.closeEditLineItemModal()
			this.$emit('update-record', event)
		},
		closeEditLineItemModal() {
			this.createEditLineItemModal = false
			this.showEditLineItemModal = false
		},
		editLineItem() {
			this.createEditLineItemModal = true
			this.showEditLineItemModal = true
		}
	},
	computed: {
		orderedQty() {
			if (this.isBulk) {
				return this.record.fieldData['Pack Size'] * this.record.fieldData['Pack Quantity'] + ' ' + this.record.fieldData['Pack Size UoM'] + ' at ' + (this.record.fieldData['Percent Fill'] * 100.0).toFixed(2) + '%'
			} else {
				return this.record.fieldData['Pack Quantity'] + ' ' + this.record.fieldData['Pack Quantity UoM'] + ' at ' + (this.record.fieldData['Percent Fill'] * 100.0).toFixed(2) + '%'
			}
		},
		showStage() {
			return this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].includes('**') && this.record.fieldData['YI Package Size Bulk Blend Chosen Stage'] && this.record.fieldData['YI Package Size Bulk Blend Chosen Stage'].length > 0;
		},
		showUnit() {
			return this.record.fieldData['NDC Number'] && this.record.fieldData['NDC Number'].includes('**') && this.record.fieldData['YI Package Size Bulk Blend'] && this.record.fieldData['YI Package Size Bulk Blend'] > 0
				&& this.record.fieldData['YI Package Size Bulk Blend UoM'] && this.record.fieldData['YI Package Size Bulk Blend UoM'].length > 0
		}
	},
}
</script>

<style scoped>
.converter-divider {
    border-left: 1px solid rgba(0, 0, 0, 0.1) !important;
}
</style>